import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBolt,
  faBrush,
  faCar,
  faCircleQuestion,
  faCode,
  faEnvelope,
  faGaugeHigh,
  faGlobe,
  faLayerGroup,
  faScrewdriverWrench,
  faShieldHalved,
  faShirt,
  faStar,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {
  faDiscord,
  faFacebook,
  faGithub,
  faInstagram,
  faTiktok,
  faTwitch,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

export type IconSet = "general" | "social";

export interface IconOption {
  value: string;
  label: string;
  icon: IconDefinition;
}

const fallbackOption: IconOption = { value: "", label: "No icon", icon: faCircleQuestion };

export const generalIconOptions: IconOption[] = [
  fallbackOption,
  { value: "brush", label: "Brush / Design", icon: faBrush },
  { value: "car", label: "Vehicle", icon: faCar },
  { value: "uniform", label: "Uniform", icon: faShirt },
  { value: "spark", label: "Spark", icon: faBolt },
  { value: "shield", label: "Shield", icon: faShieldHalved },
  { value: "speed", label: "Speed", icon: faGaugeHigh },
  { value: "layers", label: "Layers", icon: faLayerGroup },
  { value: "star", label: "Featured", icon: faStar },
  { value: "tools", label: "Tools", icon: faScrewdriverWrench },
  { value: "code", label: "Code", icon: faCode },
  { value: "community", label: "Community", icon: faUsers },
];

export const socialIconOptions: IconOption[] = [
  fallbackOption,
  { value: "discord", label: "Discord", icon: faDiscord },
  { value: "instagram", label: "Instagram", icon: faInstagram },
  { value: "x-twitter", label: "X / Twitter", icon: faXTwitter },
  { value: "youtube", label: "YouTube", icon: faYoutube },
  { value: "tiktok", label: "TikTok", icon: faTiktok },
  { value: "twitch", label: "Twitch", icon: faTwitch },
  { value: "facebook", label: "Facebook", icon: faFacebook },
  { value: "github", label: "GitHub", icon: faGithub },
  { value: "website", label: "Website", icon: faGlobe },
  { value: "email", label: "Email", icon: faEnvelope },
];

const optionsBySet: Record<IconSet, IconOption[]> = {
  general: generalIconOptions,
  social: socialIconOptions,
};

export function getIconOption(value: string | null | undefined, iconSet: IconSet = "general") {
  return optionsBySet[iconSet].find((option) => option.value === value) ?? fallbackOption;
}
